import * as React from 'react';
import { IconProps } from '../types';

const IcPhone = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g fill={props?.fill ?? '#232F3E'} clipPath="url(#a)">
      <path d="M16.898 8.397a3.84 3.84 0 0 1 .993 1.838c.124.49.497.735.87.735h.123c.497-.122.87-.613.745-1.103-.248-1.103-.745-2.083-1.49-2.819-.744-.735-1.737-1.225-2.854-1.47-.497-.123-.993.245-1.117.735 0 .49.248.98.744 1.103.745.123 1.366.49 1.986.98Z" />
      <path d="M20.746 4.597c-1.49-1.47-3.475-2.45-5.585-2.573-.497-.123-.87.245-.993.735 0 .49.372.98.868.98 1.614.123 3.228.98 4.469 2.084 1.241 1.103 1.986 2.696 2.11 4.412 0 .49.497.858.869.858h.124c.497 0 .869-.49.869-.98-.248-2.207-1.241-4.045-2.73-5.516ZM18.381 15.888c-.869-.123-1.738-.368-2.607-.613-.372-.123-.744-.123-.993-.123-.248 0-.62.246-.869.49l-1.24 1.226a14.981 14.981 0 0 1-5.586-5.515l1.24-1.225c.125-.245.373-.613.373-.98 0-.368 0-.736-.124-.981-.248-.858-.496-1.716-.62-2.574 0-.49-.249-.858-.621-1.103S6.589 4 6.093 4H3.362c-.248 0-.497 0-.745.123-.248.122-.496.245-.62.49-.125.245-.373.367-.373.613-.124.245-.124.49-.124.735.248 2.819 1.241 5.515 2.855 7.966 1.49 2.206 3.351 4.167 5.585 5.515 2.359 1.593 5.214 2.573 8.069 2.819.248 0 .496 0 .744-.123.249-.123.497-.245.621-.368.248-.122.372-.367.497-.613.124-.245.124-.49.124-.735v-2.819c0-.49-.125-.857-.497-1.225-.248-.245-.62-.49-1.117-.49Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h24v24H.5z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcPhone;
